import { db } from "../../config/firebase";
import {
  collection,
  doc,
  getDocs,
  query,
  where,
  updateDoc,
  Timestamp,
} from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../config/firebase";

const waitForAuthUser = () =>
  new Promise((resolve) => {
    if (auth.currentUser) {
      resolve(auth.currentUser);
      return;
    }

    const unsubscribe = onAuthStateChanged(
      auth,
      (user) => {
        unsubscribe();
        resolve(user);
      },
      () => {
        unsubscribe();
        resolve(null);
      }
    );
  });

const requireAuthenticatedUserId = async () => {
  const user = await waitForAuthUser();
  const userId = user?.uid;
  if (!userId) {
    throw new Error("User not authenticated");
  }
  return userId;
};

const getPendingBookings = async () => {
  const userId = await requireAuthenticatedUserId();
  const colRef = collection(db, "bookings");
  const q = query(colRef, where("hostUserId", "==", userId), where("status", "==", "pending"));
  const snap = await getDocs(q);
  const bookings = [];
  snap.forEach((docSnap) => {
    const { createdAt, updatedAt, ...rest } = docSnap.data();
    bookings.push({ id: docSnap.id, ...rest });
  });
  return bookings.sort((a, b) => {
    const aTime = a.startAt?.seconds || 0;
    const bTime = b.startAt?.seconds || 0;
    return aTime - bTime;
  });
};

const updateBookingStatus = async (bookingId, status) => {
  const userId = await requireAuthenticatedUserId();
  const docRef = doc(db, "bookings", bookingId);
  await updateDoc(docRef, {
    status,
    updatedAt: Timestamp.now(),
    hostUserId: userId,
  });
};

const bookingAdminService = {
  getPendingBookings,
  updateBookingStatus,
};

export default bookingAdminService;
